<template>
  <div>
    <div>
      <el-form :disabled="!isOk" :inline="true" ref="form2">
        <el-form-item>
          <el-button type="primary" @click="handleAdd">新增</el-button>
          <el-button type="primary" @click="handleExport">导出</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div align="center">
      <el-table :data="tableData" ref="dataTable" style="width: 100%">
        <el-table-column type="index" label="序号" width="50"/>
        <el-table-column prop="holiday" label="节假日" width="200" show-overflow-tooltip/>
        <el-table-column prop="desc" label="放假时间" width="200" show-overflow-tooltip/>
        <el-table-column prop="days" label="天数" width="80"/>
        <el-table-column prop="remark" label="调休上班时间" width="500" show-overflow-tooltip/>
        <el-table-column label="操作" width="160" align="center">
          <template slot-scope="scope">
            <el-button type="text" icon="el-icon-edit" @click="handleSet(scope.row)" size="small">修改</el-button>
            <el-button type="text" icon="el-icon-edit" @click="handleDel(scope.row)" size="small">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" :close-on-click-modal="false" width="800px">
      <el-form ref="form" :model="form" label-width="120px">
        <el-form-item label="年份" prop="year" type="number" :rules="[{required: true, message: '年份为空'}]">
          <el-input :disabled="form.id > 0" v-model="form.year" maxlength="50" style="width: 580px"></el-input>
        </el-form-item>
        <el-form-item label="节假日" prop="holiday" :rules="[{required: true, message: '节假日为空'}]">
          <el-input v-model="form.holiday" maxlength="200" style="width: 580px"></el-input>
        </el-form-item>
        <el-form-item label="放假时间" prop="desc" :rules="[{required: true, message: '放假时间为空'}]">
          <el-input v-model="form.desc" maxlength="200" style="width: 580px"></el-input>
        </el-form-item>
        <el-form-item label="天数" prop="days" type="number" :rules="[{required: true, message: '天数为空'}]">
          <el-input v-model="form.days" maxlength="50" style="width: 580px"></el-input>
        </el-form-item>
        <el-form-item label="调休上班时间" prop="remark">
          <el-input v-model="form.remark" maxlength="200" style="width: 580px"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancel('form')">取消</el-button>
        <el-button type="primary" v-if="dialogStatus==='add'" @click="add('form')"><span>确定</span></el-button>
        <el-button type="primary" v-if="dialogStatus==='set'" @click="set('form')"><span>确定</span></el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import * as http from '../api/http'
import * as util from '../util/util'
import global from '../components/Global'

export default {
  name: 'Holiday',
  data () {
    return {
      isOk: false,
      dialogStatus: '',
      dialogTitle: '',
      dialogVisible: false,
      param: {},
      tableData: [],
      form: {}
    }
  },
  created () {
    if (global.uid <= 0 || global.token === '') {
      this.$router.push('/')
      return
    }
    this.list()
  },
  methods: {
    cancel () {
      this.dialogVisible = false
    },
    add (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.id = 0
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-holiday/add/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('新增成功')
              this.list()
            } else {
              this.$message.error('新增失败:' + res)
            }
          }
        )
      })
    },
    set (formName) {
      const set = this.$refs
      set[formName].validate(valid => {
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        http.post(global.url0 + 'nsy-holiday/set/', this.form).then(
          res => {
            if (res === 200) {
              this.dialogVisible = false
              this.$message.success('修改成功')
              this.list()
            } else {
              this.$message.error('修改失败:' + res)
            }
          }
        )
      })
    },
    handleAdd () {
      this.form = {}
      this.form.id = 0
      this.dialogStatus = 'add'
      this.dialogTitle = '新增'
      this.dialogVisible = true
    },
    handleSet (row) {
      this.form = JSON.parse(JSON.stringify(row))
      this.dialogStatus = 'set'
      this.dialogTitle = '修改'
      this.dialogVisible = true
    },
    handleDel (row) {
      this.$confirm('此操作将永久删除记录，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.form = {}
        this.form.uid = this.param.uid
        this.form.token = this.param.token
        this.form.id = row.id
        http.post(global.url0 + 'nsy-holiday/del/', this.form).then(
          res => {
            if (res === 200) {
              this.$message.success('删除成功')
              this.list()
            } else {
              this.$message.error('删除失败')
            }
          }
        )
      })
    },
    list () {
      this.isOk = false
      this.tableData = []
      this.param.uid = global.uid
      this.param.token = global.token

      http.post(global.url0 + 'nsy-holiday/list/', this.param).then(
        res => {
          let resStr = res.data.toString
          if (resStr.length > 0 && !String.startsWith(resStr, '[')) {
            this.$message.error(res)
            return
          }
          // console.log(res)
          this.tableData = res.data
          this.isOk = true
        }
      )
    },
    handleExport () {
      util.toExcel(this.$refs.dataTable.columns, this.tableData, 'Holiday')
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a {
  color: #42b983;
}
</style>



// WEBPACK FOOTER //
// src/views/Holiday.vue